// extracted by mini-css-extract-plugin
module.exports = {"localFather":"MobileSign__localFather__Dhfqi","confirmFather":"MobileSign__confirmFather__UIhzk","conform":"MobileSign__conform__3eWjZ"};